import TableBody from "@material-ui/core/TableBody";
// material-ui
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import React, { Component } from "react";
// styles
import styles from "./styles";

class RendTableBody extends Component {
  static propTypes = {
    classes: PropTypes.object,
    children: PropTypes.any,
  };

  render() {
    const { children } = this.props;

    return <TableBody>{children}</TableBody>;
  }
}

export default withStyles(styles)(RendTableBody);
